module.exports = __webpack_public_path__ + "img/13.91d77d7d.svg";